@if (!loading) {
  <h1>{{ content.paymentHeadline }}</h1>
  <hr class="blue mb-4">
  @if (hasStripeId) {
    <h6 class="text-danger">There was a problem with your subscription. Please update your billing information.</h6>
  }
  <div class="my-4">
    <markdown [data]="content.paymentContent"></markdown>
  </div>
  @if (!paymentService.isUk) {
    <div
      class="col-6 offset-3 my-3 p-3 text-white payment-info-block bg-dark-blue"
      tooltipClass="payment-info-block-tooltip"
      [ngbTooltip]="content.paymentInfoBlocks[0].paymentBlockTooltip"
      container="body"
      placement="right">
      <markdown [data]="content.paymentInfoBlocks[0].paymentBlockInfo"></markdown>
    </div>
  }
  @if (paymentService.isUk) {
    <div
      class="col-6 offset-3 my-3 p-3 text-white payment-info-block bg-dark-blue"
      tooltipClass="payment-info-block-tooltip"
      [ngbTooltip]="content.paymentInfoBlocks[3].paymentBlockTooltip"
      container="body"
      placement="right">
      <markdown [data]="content.paymentInfoBlocks[3].paymentBlockInfo"></markdown>
    </div>
  }
  <div
    class="col-6 offset-3 my-3 p-3 text-white payment-info-block"
    [ngbTooltip]="content.paymentInfoBlocks[1].paymentBlockTooltip"
    container="body"
    tooltipClass="payment-info-block-tooltip"
    placement="right">
    <markdown [data]="content.paymentInfoBlocks[1].paymentBlockInfo"></markdown>
  </div>
  <div
    class="col-6 offset-3 mt-3 mb-4 p-3 text-white payment-info-block bg-royal-blue"
    [ngbTooltip]="content.paymentInfoBlocks[2].paymentBlockTooltip"
    container="body"
    tooltipClass="payment-info-block-tooltip"
    placement="right">
    <markdown [data]="content.paymentInfoBlocks[2].paymentBlockInfo"></markdown>
  </div>
  <div class="custom-control custom-checkbox">
    <input type="checkbox" (change)="switchUsersAgreement($event)" id="agreeToUserAgreement" class="custom-control-input">
    <label class="custom-control-label pb-4" for="agreeToUserAgreement">
      <markdown [data]="content.paymentUserAgreement"></markdown>
    </label>
  </div>
  <app-stripe-card (tokenReady)="checkout($event)"></app-stripe-card>
  <div class="mt-4 text-center">
    <a href="" (click)="logout()">Log In With a different account</a>
  </div>
} @else {
  <div class="center-div">
    <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
  </div>
}

